import { createReducer, on } from '@ngrx/store';
import { UserInfoFormData } from '../_actions/user-info.actions';
import * as UserInfoActions from '../_actions/user-info.actions';

export interface UserInfoState {
  formData: UserInfoFormData | null;
  loading: boolean;
  error: any;
  submitted: boolean;
}

export const initialState: UserInfoState = {
  formData: null,
  loading: false,
  error: null,
  submitted: false
};

export const userInfoReducer = createReducer(
  initialState,
  on(UserInfoActions.submitUserInfo, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserInfoActions.submitUserInfoSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    submitted: true,
    error: null
  })),
  on(UserInfoActions.submitUserInfoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    submitted: false
  }))
); 